module.exports = __webpack_public_path__ + "static/img/u960.1b3097e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u960.svg
// module id = qxmF
// module chunks = 209